import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LandingHero } from "@/components/landing/LandingHero";
import { TryDecree } from "@/components/landing/TryDecree";
import { HowItWorks, FeatureShowcase } from "@/components/landing/Sections";
import { PricingSection, ReviewsSection } from "@/components/landing/PricingReviews";
import { ScriptureFoundation, FAQ, FinalCTA } from "@/components/landing/FoundationFaq";

export default function Welcome() {
  const { user, loading } = useAuth();

  if (!loading && user) return <Navigate to="/feed" replace />;

  return (
    <div data-testid="landing-page">
      <LandingHero />
      <TryDecree />
      <HowItWorks />
      <FeatureShowcase />
      <PricingSection />
      <ReviewsSection />
      <ScriptureFoundation />
      <FAQ />
      <FinalCTA />
    </div>
  );
}
